import React,{useState} from 'react';
import {Button, Col,Form,message,Row,Select  } from "antd";
import './index.css'
import { useSelector,useDispatch } from 'react-redux';
import {toSetting} from '../../store/modules/fontSize'
//设置
const SettingApp =(props)=>{
    //父组件传输
    const {handleCancelModel} = props
    //缓存
    const {size} = useSelector(state=>state.fontSizeChange)
    const dispatch = useDispatch()
    //form组件
    const [form] = Form.useForm();
    const onFinish = (values) => {
        if(values.size){
            dispatch(toSetting(values.size))
            handleCancelModel()
        }else{
            handleCancelModel()
        }
    };
    //校验失败
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    //重置内容
    const formReset = ()=>{
        form.resetFields()
    }

    return (
        <div className="SettingApp">
                <Form onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={18}>
                            <div className='fL'>界面语言 UI Language</div>
                            <div>
                                <Select
                                    defaultValue="zh - 简体中文"
                                    style={{
                                        width: '100%',
                                    }}
                                    options={[
                                        {
                                            value: 'zh - 简体中文',
                                            label: 'zh - 简体中文',
                                        }
                                    ]}
                                />
                            </div>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <div className='fL textCenter'>正文字号</div>
                            <div>
                                <Form.Item label="" name="size">
                                <Select
                                    defaultValue={size}
                                    style={{
                                        width: '100%',
                                    }}
                                    options={[
                                        { value: '小', label: '小', },
                                        { value: '中', label: '中', },
                                        { value: '大', label: '大', }
                                    ]}
                                />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>


                    <Form.Item>
                        <div className='textRight'>
                            <Button className='selfBtn' htmlType="submit">
                                确定
                            </Button>
                            <Button className='selfBtn btn2' onClick={handleCancelModel}>
                                取消
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
        </div>
    )
}

export default SettingApp
